import { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { Body, H2 } from '@rikstv/shared-components';

import { LinkButton } from '../linkButton/LinkButton';

import styles from './ErrorPage.module.css';

export const AssetNotFound: FC = () => {
  const { pathname } = useLocation();

  // Keyed on pathname: route elements are not remounted between ids, so one instance can show two missing assets
  useEffect(() => {
    window.dataLayer?.push({ event: '404page' });
  }, [pathname]);

  return (
    <>
      <Helmet>
        {/*
          Remove not found assets from search index as url to this component will still be an asset/SCP-url
          https://support.google.com/webmasters/thread/11770516?hl=en&msgid=11778983
          https://developers.google.com/search/docs/crawling-indexing/robots-meta-tag
        */}
        <meta name="robots" content="noindex, noarchive" />
      </Helmet>
      <article className={styles.errorPage}>
        <div className={styles.errorPageContent}>
          <H2>Au da, vi finner dessverre ikke innholdet du leter etter.</H2>
          <br />
          <Body>Klikk under for å gå til forsiden</Body>
          <br />
          <LinkButton to="/">Til forsiden</LinkButton>
        </div>
      </article>
    </>
  );
};
